// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchKeywordsModal_wrapper__yAcB8"};